module.exports = __webpack_public_path__ + "images/dea4ed1ab096de8d430807f433283960.svg";